import UploadFile from 'components/DataSetsEmptyList/components/UploadFile/UploadFile';

import type IMaterialConfigEmpty from './interfaces/IMaterialConfigEmpty';

import styles from './scss/MaterialConfigEmpty.module.scss';

function MaterialConfigEmpty({
  title, subTitle, uploadControl, onDownloadExample, titleBox, subTitleBox,
  hideSubTitleWrapper, openModal, titleDropdownButton, onClickDropdownButton, optionsDropdown,
}: IMaterialConfigEmpty) {
  return (
    <div className={styles.wrapper}>
      <UploadFile
        uploadControl={uploadControl}
        onDownloadExample={onDownloadExample}
        className={styles.uploadFile}
        title={title}
        hint={subTitle}
        subTitleBox={subTitleBox}
        titleBox={titleBox}
        hideSubTitleWrapper={hideSubTitleWrapper}
        openModal={openModal}
        titleDropdownButton={titleDropdownButton}
        onClickDropdownButton={onClickDropdownButton}
        optionsDropdown={optionsDropdown}
        hideDragHint
      />
    </div>
  );
}

export default MaterialConfigEmpty;
